export enum eLinkSize {
    Small = "link-size-small",
    Standard = "link-size-standard",
    Medium = "link-size-medium",
    Large = "link-size-large"
}